module.exports = __webpack_public_path__ + "static/media/veteran.9e85938e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/veteran.svg
// module id = 653
// module chunks = 36